import React from 'react'
import Pt from 'prop-types'
import Mpt from 'react-moment-proptypes'

import { convertToDuration } from './util'

export default function Months({
  Component = 'span',
  dropOne = false,
  duration,
}) {
  duration = convertToDuration(duration)

  const durationMonths = Math.abs(Math.round(duration.asMonths() * 10) / 10)
  const displayNumber = (dropOne && durationMonths === 1) ? '' : `${durationMonths} `

  return (
    <Component>
      {displayNumber}month{durationMonths !== 1 && 's'}
    </Component>
  )
}

Months.propTypes = {
  Component: Pt.node,
  dropOne: Pt.bool,
  duration: Mpt.momentDurationObj.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Time/Months.jsx